import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { ActionBar, Button } from '../ui';

const NavigationButtons = ({ 
  onNext, 
  nextLabel = 'Continuar', 
  nextHint = '',
  nextHintId = 'navigation-next-hint',
  disableNext = false, 
  isLoading = false,
  onBack = null,
  backLabel = 'Volver',
  primaryButtonId = undefined
}) => {
  const [isButtonProcessing, setIsButtonProcessing] = useState(false);

  const handleNextClick = async (e) => {
    // Prevenir múltiples clics en el botón
    if (isButtonProcessing || isLoading) {
      e.preventDefault();
      return;
    }

    setIsButtonProcessing(true);
    
    try {
      if (onNext) {
        await onNext();
      }
    } catch (error) {
      console.error('Error en NavigationButtons:', error);
    } finally {
      setIsButtonProcessing(false);
    }
  };

  return (
    <ActionBar
      secondary={
        onBack ? (
          <Button variant="link" onClick={onBack}>
            <FontAwesomeIcon icon={faArrowLeft} aria-hidden="true" />
            {backLabel}
          </Button>
        ) : null
      }
      primary={
        onNext ? (
          <div className="rg-navigation-buttons__primary">
            <Button
              id={primaryButtonId}
              variant="primary"
              onClick={handleNextClick}
              disabled={disableNext || isLoading || isButtonProcessing}
              aria-describedby={nextHint ? nextHintId : undefined}
            >
              {(isLoading || isButtonProcessing) && (
                <span className="spinner-border spinner-border-sm" aria-hidden="true" />
              )}
              {nextLabel}
              <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
            </Button>
            {nextHint ? (
              <p id={nextHintId} className="rg-navigation-buttons__hint">
                {nextHint}
              </p>
            ) : null}
          </div>
        ) : null
      }
    />
  );
};

export default NavigationButtons;
